export default "__VITE_ASSET__CK9pqK4J__"